import React from 'react';
import { Shimmer } from '../../CommonComponents/OPL/Shimmer/Shimmer';

export const InsuranceLoading = () => {
  return (
    <>
      <Shimmer width="100%" height="200px" mt="16" />
      <Shimmer width="100%" height="50px" mt="16" />
    </>
  );
};
